import { InfoIcon } from '@assets/icons';
import { Tooltip } from '@components/tooltip';
import { Typography } from '@components/typography';
import { SxProps, Tab, TabProps, useTheme } from '@mui/material';
import { Ref, forwardRef } from 'react';

type LandingPageNavigationTabProps = TabProps & {
  expired?: boolean;
};

export const LandingPageNavigationTab = forwardRef(
  ({ expired, label, ...rest }: LandingPageNavigationTabProps, ref: Ref<HTMLDivElement>) => {
    const { palette, typography } = useTheme();

    const tabStyles = {
      ...typography.body2,
      lineHeight: '44px',
      height: '44px',
      paddingY: 0,
      width: '100%',
      backgroundColor: palette.background.paper,
      textTransform: 'none',
      maxWidth: '100%',
      display: 'flex',
      color: palette.text.paper,
      borderTopLeftRadius: '4px',
      borderBottomLeftRadius: '4px',
      marginLeft: 2,
      paddingLeft: 4,
      '&.MuiButtonBase-root.MuiTab-root:hover': {
        backgroundColor: palette.backgroundHover.default,
      },
      '&.MuiButtonBase-root.MuiTab-root.Mui-selected': {
        marginLeft: 2,
        paddingLeft: 4,
        backgroundColor: palette.background.default,
        color: palette.mode === 'dark' ? palette.common.white : palette.text.primary,
        borderTopLeftRadius: '4px',
        borderBottomLeftRadius: '4px',
      },
    } as SxProps;

    return (
      <Tab
        sx={{ ...tabStyles, justifyContent: 'space-between', whiteSpace: 'nowrap' }}
        label={label}
        ref={ref}
        disableRipple
        icon={
          expired ? (
            <Tooltip
              title={<Typography variant="caption2">Your subscription has expired</Typography>}
              placement="top"
            >
              <InfoIcon size={24} />
            </Tooltip>
          ) : null
        }
        iconPosition="end"
        {...rest}
      />
    );
  },
);
